
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser.ts'
export { Prisma }
export * as $Enums from './enums.ts'
export * from './enums.ts';
/**
 * Model Account
 * 
 */
export type Account = Prisma.AccountModel
/**
 * Model AdminPointAward
 * 
 */
export type AdminPointAward = Prisma.AdminPointAwardModel
/**
 * Model AppNotification
 * 
 */
export type AppNotification = Prisma.AppNotificationModel
/**
 * Model AppPermission
 * 
 */
export type AppPermission = Prisma.AppPermissionModel
/**
 * Model Audit
 * 
 */
export type Audit = Prisma.AuditModel
/**
 * Model Badge
 * 
 */
export type Badge = Prisma.BadgeModel
/**
 * Model BadgeEvent
 * 
 */
export type BadgeEvent = Prisma.BadgeEventModel
/**
 * Model BadgeOverride
 * 
 */
export type BadgeOverride = Prisma.BadgeOverrideModel
/**
 * Model BadgeToParticipant
 * 
 */
export type BadgeToParticipant = Prisma.BadgeToParticipantModel
/**
 * Model Blast
 * 
 */
export type Blast = Prisma.BlastModel
/**
 * Model Comment
 * 
 */
export type Comment = Prisma.CommentModel
/**
 * Model Compliment
 * 
 */
export type Compliment = Prisma.ComplimentModel
/**
 * Model CoreValueTag
 * 
 */
export type CoreValueTag = Prisma.CoreValueTagModel
/**
 * Model Event
 * 
 */
export type Event = Prisma.EventModel
/**
 * Model Facility
 * 
 */
export type Facility = Prisma.FacilityModel
/**
 * Model FacilityOnPosts
 * 
 */
export type FacilityOnPosts = Prisma.FacilityOnPostsModel
/**
 * Model Feed
 * 
 */
export type Feed = Prisma.FeedModel
/**
 * Model FeedSubscription
 * 
 */
export type FeedSubscription = Prisma.FeedSubscriptionModel
/**
 * Model HistoricalFacilitySavings
 * 
 */
export type HistoricalFacilitySavings = Prisma.HistoricalFacilitySavingsModel
/**
 * Model HoursFileMapping
 * 
 */
export type HoursFileMapping = Prisma.HoursFileMappingModel
/**
 * Model RosterFileMapping
 * 
 */
export type RosterFileMapping = Prisma.RosterFileMappingModel
/**
 * Model IncentivePeriod
 * 
 */
export type IncentivePeriod = Prisma.IncentivePeriodModel
/**
 * Model IncentiveProgram
 * 
 */
export type IncentiveProgram = Prisma.IncentiveProgramModel
/**
 * Model IncentiveProgramsOnFacilities
 * 
 */
export type IncentiveProgramsOnFacilities = Prisma.IncentiveProgramsOnFacilitiesModel
/**
 * Model IngestJob
 * 
 */
export type IngestJob = Prisma.IngestJobModel
/**
 * Model JobSpecialty
 * 
 */
export type JobSpecialty = Prisma.JobSpecialtyModel
/**
 * Model EmploymentStatusMapping
 * 
 */
export type EmploymentStatusMapping = Prisma.EmploymentStatusMappingModel
/**
 * Model LinkMappings
 * 
 */
export type LinkMappings = Prisma.LinkMappingsModel
/**
 * Model MagicLinkOtp
 * 
 */
export type MagicLinkOtp = Prisma.MagicLinkOtpModel
/**
 * Model OAuthClient
 * OAuth client permitted to request MCP access. Registration is deliberately manual: dynamic client
 * registration is not exposed, so the only clients that can start a flow are ones engineering has
 * vetted and issued credentials for.
 */
export type OAuthClient = Prisma.OAuthClientModel
/**
 * Model OAuthAuthorizationCode
 * Single-use authorization code. Stored as a hash and marked consumed on exchange, so a code
 * captured from a redirect URL, log, or browser history cannot be replayed.
 */
export type OAuthAuthorizationCode = Prisma.OAuthAuthorizationCodeModel
/**
 * Model OAuthAccessToken
 * Bearer token presented to the MCP endpoint. Opaque and stored hashed rather than self-contained
 * like a JWT, so revoking one takes effect on the next request instead of at expiry.
 */
export type OAuthAccessToken = Prisma.OAuthAccessTokenModel
/**
 * Model OAuthRefreshToken
 * Long-lived credential used to mint access tokens. Rotated on every use: presenting an already
 * rotated token means it leaked, which revokes the whole family rather than issuing more.
 */
export type OAuthRefreshToken = Prisma.OAuthRefreshTokenModel
/**
 * Model OAuthConsent
 * Records that an operator approved a client for a set of scopes, so reconnecting does not
 * re-prompt. Revoking forces a fresh consent screen on the next authorization.
 */
export type OAuthConsent = Prisma.OAuthConsentModel
/**
 * Model Message
 * 
 */
export type Message = Prisma.MessageModel
/**
 * Model ModuleData
 * 
 */
export type ModuleData = Prisma.ModuleDataModel
/**
 * Model ModuleRun
 * 
 */
export type ModuleRun = Prisma.ModuleRunModel
/**
 * Model Participant
 * 
 */
export type Participant = Prisma.ParticipantModel
/**
 * Model ParticipantGroup
 * 
 */
export type ParticipantGroup = Prisma.ParticipantGroupModel
/**
 * Model ParticipantToFacility
 * 
 */
export type ParticipantToFacility = Prisma.ParticipantToFacilityModel
/**
 * Model ParticipantToGroup
 * 
 */
export type ParticipantToGroup = Prisma.ParticipantToGroupModel
/**
 * Model ParticipantSurvey
 * 
 */
export type ParticipantSurvey = Prisma.ParticipantSurveyModel
/**
 * Model ParticipantToIncentiveProgram
 * 
 */
export type ParticipantToIncentiveProgram = Prisma.ParticipantToIncentiveProgramModel
/**
 * Model PayDifferentialOrder
 * 
 */
export type PayDifferentialOrder = Prisma.PayDifferentialOrderModel
/**
 * Model PaySchedule
 * 
 */
export type PaySchedule = Prisma.PayScheduleModel
/**
 * Model PayScheduleDates
 * 
 */
export type PayScheduleDates = Prisma.PayScheduleDatesModel
/**
 * Model PinnedPost
 * 
 */
export type PinnedPost = Prisma.PinnedPostModel
/**
 * Model PointTransaction
 * 
 */
export type PointTransaction = Prisma.PointTransactionModel
/**
 * Model PointTransactionStatusEvent
 * 
 */
export type PointTransactionStatusEvent = Prisma.PointTransactionStatusEventModel
/**
 * Model Post
 * 
 */
export type Post = Prisma.PostModel
/**
 * Model PostParticipantTag
 * 
 */
export type PostParticipantTag = Prisma.PostParticipantTagModel
/**
 * Model Program
 * 
 */
export type Program = Prisma.ProgramModel
/**
 * Model ProgramPeriod
 * 
 */
export type ProgramPeriod = Prisma.ProgramPeriodModel
/**
 * Model RawSummedHoursData
 * 
 */
export type RawSummedHoursData = Prisma.RawSummedHoursDataModel
/**
 * Model RawRosterData
 * 
 */
export type RawRosterData = Prisma.RawRosterDataModel
/**
 * Model Reaction
 * 
 */
export type Reaction = Prisma.ReactionModel
/**
 * Model ReferralReward
 * 
 */
export type ReferralReward = Prisma.ReferralRewardModel
/**
 * Model Report
 * 
 */
export type Report = Prisma.ReportModel
/**
 * Model RewardOption
 * 
 */
export type RewardOption = Prisma.RewardOptionModel
/**
 * Model ScheduleCycle
 * 
 */
export type ScheduleCycle = Prisma.ScheduleCycleModel
/**
 * Model ScheduleCycleDates
 * 
 */
export type ScheduleCycleDates = Prisma.ScheduleCycleDatesModel
/**
 * Model ScheduleDates
 * 
 */
export type ScheduleDates = Prisma.ScheduleDatesModel
/**
 * Model ShiftPickupBadgeProgress
 * 
 */
export type ShiftPickupBadgeProgress = Prisma.ShiftPickupBadgeProgressModel
/**
 * Model ShiftPickupResults
 * 
 */
export type ShiftPickupResults = Prisma.ShiftPickupResultsModel
/**
 * Model SignUp
 * 
 */
export type SignUp = Prisma.SignUpModel
/**
 * Model SuperlativeQuestion
 * 
 */
export type SuperlativeQuestion = Prisma.SuperlativeQuestionModel
/**
 * Model SuperlativeVote
 * 
 */
export type SuperlativeVote = Prisma.SuperlativeVoteModel
/**
 * Model Survey
 * 
 */
export type Survey = Prisma.SurveyModel
/**
 * Model SurveyChoice
 * 
 */
export type SurveyChoice = Prisma.SurveyChoiceModel
/**
 * Model SurveyQuestion
 * 
 */
export type SurveyQuestion = Prisma.SurveyQuestionModel
/**
 * Model SurveyResponse
 * 
 */
export type SurveyResponse = Prisma.SurveyResponseModel
/**
 * Model SurveyResults
 * 
 */
export type SurveyResults = Prisma.SurveyResultsModel
/**
 * Model SurveyToAccount
 * 
 */
export type SurveyToAccount = Prisma.SurveyToAccountModel
/**
 * Model Tag
 * 
 */
export type Tag = Prisma.TagModel
/**
 * Model TangoOrder
 * 
 */
export type TangoOrder = Prisma.TangoOrderModel
/**
 * Model TenureResults
 * 
 */
export type TenureResults = Prisma.TenureResultsModel
/**
 * Model Tier
 * 
 */
export type Tier = Prisma.TierModel
/**
 * Model TierHistory
 * 
 */
export type TierHistory = Prisma.TierHistoryModel
/**
 * Model Turnover
 * 
 */
export type Turnover = Prisma.TurnoverModel
/**
 * Model User
 * 
 */
export type User = Prisma.UserModel
/**
 * Model View
 * 
 */
export type View = Prisma.ViewModel
/**
 * Model ContentSource
 * 
 */
export type ContentSource = Prisma.ContentSourceModel
/**
 * Model Evidence
 * 
 */
export type Evidence = Prisma.EvidenceModel
/**
 * Model PlayQuestion
 * 
 */
export type PlayQuestion = Prisma.PlayQuestionModel
/**
 * Model Playbook
 * 
 */
export type Playbook = Prisma.PlaybookModel
/**
 * Model PlaybookStep
 * 
 */
export type PlaybookStep = Prisma.PlaybookStepModel
/**
 * Model PlaybookEligibility
 * 
 */
export type PlaybookEligibility = Prisma.PlaybookEligibilityModel
/**
 * Model PlaybookEnrollment
 * 
 */
export type PlaybookEnrollment = Prisma.PlaybookEnrollmentModel
/**
 * Model ParticipantPlayStep
 * 
 */
export type ParticipantPlayStep = Prisma.ParticipantPlayStepModel
/**
 * Model PlaybookStepResponse
 * 
 */
export type PlaybookStepResponse = Prisma.PlaybookStepResponseModel
